import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import InquiryManagement from '../../../components/siteadmin/InquiryManagement/InquiryManagement';
import inquiryQuery from './inquiryQuery.graphql'
import { withQuery } from '../../../hoc/withGraphql';

class Inquiry extends Component {

    constructor() {
        super();
        this.state = {
            currentPage: 1,
            searchList: '',
        }
    }

    changeState = (variables) => {
        this.setState(variables)
    }

    render() {
        const { getAllInquiryQuery } = this.props;
        return (
            <div>
                <InquiryManagement
                    changeStateValues={this.changeState}
                    getAllInquiryQuery={getAllInquiryQuery}
                    currentPage={this.state.currentPage}
                    searchList={this.state.searchList}
                    refetch={getAllInquiryQuery?.refetch}
                />
            </div>
        )
    }
};

export default compose(
    withQuery(inquiryQuery, {
        name: 'getAllInquiryQuery',
        options: {
            variables: {
                currentPage: 1,
                searchList: '',
                paymentStatusFilter: '',
                reservationStatusFilter: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(Inquiry);